"use client";
import { Box } from "@mui/material";
import { styled, useTheme } from "@mui/material/styles";
import { SpaceLg, SpaceXl, SpaceXs } from "@nxt-costco-com/forge-design-tokens";
import { AD_TYPE_ONE_THIRD, AD_TYPE_ONE_FOURTH, AD_TYPE_HALF } from "./AdButler/constants.js";
const AdSetContainerStyles = (componentType) => {
  const theme = useTheme();
  let widthStyles = {};
  switch (componentType) {
    case AD_TYPE_HALF:
      widthStyles = {
        maxWidth: "50%"
      };
      break;
    case AD_TYPE_ONE_FOURTH:
      widthStyles = {
        maxWidth: "25%"
      };
      break;
    case AD_TYPE_ONE_THIRD:
      widthStyles = {
        maxWidth: "33.33%"
      };
      break;
  }
  return {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    maxWidth: "100%",
    [theme.breakpoints.down("md")]: {
      '&[data-layout="large_ad"] > div > div': {
        flexBasis: "100%"
      },
      '&[data-layout="large_half_banner"] > div > div': {
        flexBasis: "100%"
      },
      '&[data-layout="one_third"] > div, &[data-layout="half"] > div': {
        flexDirection: "column"
      }
    },
    ...widthStyles
  };
};
const StyledAdButlerBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== "adCount"
})(({ adCount = 0, theme }) => {
  return {
    "> div": {
      width: adCount === 1 ? "100%" : `calc(${100 / adCount}% - ${6 * adCount}px)`
    },
    alignItems: "start",
    display: "flex",
    flexWrap: "wrap",
    gap: "24px",
    justifyContent: "space-between",
    [theme.breakpoints.down("md")]: {
      "> div": {
        flexBasis: "45%",
        flexGrow: 1
      }
    }
  };
});
const CostcoFlexBox = {
  display: "flex"
};
const StyledAdButlerInnerBox = {
  padding: "8px 15px 8px 15px"
};
const blockStyles = {
  banner: {
    marginBottom: SpaceXs,
    marginTop: SpaceXs,
    width: "100%"
  },
  productCategory: {
    display: "flex",
    flexWrap: "wrap",
    gap: SpaceXs
  }
};
const adobeCategoryContainerStyles = {
  alignItems: "start",
  columnGap: { lg: 0, md: SpaceXl },
  display: "flex",
  flexWrap: "wrap",
  rowGap: SpaceLg
};
export {
  AdSetContainerStyles,
  CostcoFlexBox,
  StyledAdButlerBox,
  StyledAdButlerInnerBox,
  adobeCategoryContainerStyles,
  blockStyles
};
